import { JSX } from 'react';

import { Stack, useMediaQuery, useTheme } from '@mui/system';
import { useTranslation } from 'react-i18next';

import ActionButton from '~components/buttons/actionButton';
import ActionButtonStyle from '~components/buttons/actionButtonStyle';
import CloseableDrawer from '~components/drawers/closeableDrawer';
import { StatusVariant } from '~enums';
import { Dimens } from '~themes';

interface Props {
	isOpen: boolean;
	filters: JSX.Element[];
	onApply: () => void;
	onClose: () => void;
	onReset: () => void;
}

const DataGridFiltersDrawer = ({ isOpen, filters, onApply, onClose, onReset }: Props) => {
	const theme = useTheme();
	const { t } = useTranslation();
	const largerThanMd = useMediaQuery(theme.breakpoints.up('md'));

	return (
		<CloseableDrawer
			title={t('selectFilters', { ns: 'actions' })}
			open={isOpen && !largerThanMd}
			anchor='right'
			onClose={onClose}
			slotProps={{
				paper: {
					sx: {
						// Makes the drawer full screen on smaller devices
						left: {
							xs: 0,
							md: 'unset',
						},
					},
				},
			}}
		>
			<Stack sx={{ height: '100%' }}>
				{/* Search will always remain on the screen, never in the drawer. 
                Which is why we slice off the first element */}
				<Stack gap={Dimens.spacingLg} sx={{ flex: 1 }}>
					{filters.slice(1)}
				</Stack>
				<Stack direction='row' gap={Dimens.spacingMd}>
					<ActionButton
						label={t('clearFilters', { ns: 'actions' })}
						style={ActionButtonStyle.Bordered}
						sx={{ width: '100%' }}
						onClick={() => onReset()}
					/>
					<ActionButton
						label={t('apply', { ns: 'actions' })}
						variant={StatusVariant.Brand}
						sx={{ width: '100%' }}
						onClick={() => onApply()}
					/>
				</Stack>
			</Stack>
		</CloseableDrawer>
	);
};

export default DataGridFiltersDrawer;
